/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.custom.enrichment.rpc.client.PropertyConfigService
 */

export const createPropertyConfigRpc = {
  serviceName: 'com.hubspot.custom.enrichment.rpc.client.PropertyConfigService',
  rpcName: 'createPropertyConfig',
  auth: 'app',
  fingerprint: '_BEjARoZSX55Bnwa4Xy0l_Vs6gp3vMTX'
};
export const getPropertiesRpc = {
  serviceName: 'com.hubspot.custom.enrichment.rpc.client.PropertyConfigService',
  rpcName: 'getProperties',
  auth: 'app',
  fingerprint: '-DJwJVviBMoXwaNQRpTtRpwP6LXzGzX8'
};
export const updatePropertyConfigRpc = {
  serviceName: 'com.hubspot.custom.enrichment.rpc.client.PropertyConfigService',
  rpcName: 'updatePropertyConfig',
  auth: 'app',
  fingerprint: 'fWaPMwlttOunZd3A5S4XwPVs6gp3vMTX'
};
export const deletePropertyConfigRpc = {
  serviceName: 'com.hubspot.custom.enrichment.rpc.client.PropertyConfigService',
  rpcName: 'deletePropertyConfig',
  auth: 'app',
  fingerprint: 'uyIjt8OMWCyfahbqfjhb0_Vs6gp3vMTX'
};